/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Smarts
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import SmartsException from './SmartsException'

const VIZREC_SUPPORTED_CHARTS_URL = 'v1/smarts/visualization-recommender/supportedCharts'
const CONTENT_RECOMMENDER_URL = 'v1/smarts/content-recommender/recommend'
const SMART_MODULE_URL = 'v1/smarts/module'
const VIZREC_RECOMMEND_URL = 'v1/smarts/visualization-recommender/recommend'
// const VIZREC_CHARTINFO_URL = 'v1/smarts/visualization-recommender/chartInfo'
// const INSIGHTS_INFLUENCERS_URL = 'v1/smarts/insights/influencers'
// const INSIGHTS_INTERESTING_URL = 'v1/smarts/insights/interesting-fields'
// const INSIGHTS_POTENTIAL_URL = 'v1/smarts/insights/potential-targets'
// const INSIGHTS_RELATEDVIZ_URL = 'v1/smarts/insights/related-visualizations'
// const INSIGHTS_RELATED_URL = 'v1/smarts/insights/related-columns'


export default class SmartsAPI {

	constructor({ logger, ajaxService }) {
		this._logger = logger
		this._ajaxService = ajaxService
		this._cachedSupportedChartTypes = null
	}

	/**
	 * Process SmartsService response
	 *
	 * @param  {object} HTTPResponse
	 * @returns {object}
	 */
	_processResponse({ data }) {
		return data
	}

	/**
	 * @param  {object} HTTPError
	 */
	_processError({ jqXHR }) {
		const { responseJSON } = jqXHR
		if( responseJSON ) {
			throw new SmartsException( responseJSON.status, responseJSON.details )
		} else {
			const serverRequestError = jqXHR.error()
			throw new SmartsException( serverRequestError.status, serverRequestError.responseText)
		}
	}

	/**
	 * @param  {string} url
	 * @param  {object} qs
	 * @returns {promise}
	 */
	GET(url, qs) {
		return this._ajaxService.ajax({
			url,
			type: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
			qs,
			processData: false
		})
			.then( response => this._processResponse(response) )
			.catch( error => this._processError(error) )
	}

	/**
	 * @param  {string} url
	 * @param  {object} payload
	 * @returns {promise}
	 */
	POST(url, payload) {
		return this._ajaxService.ajax({
			type: 'POST',
			url: url,
			contentType: 'application/json',
			data: JSON.stringify(payload),
			xhrFields: {
				withCredentials: true
			}
		})
			.then( response => this._processResponse(response) )
			.catch( error => this._processError(error) )
	}

	/**
	 * Request the recommender supported chart types
	 *
	 * @returns {Set}
	 */
	getRecommenderSupportedChartTypes() {
		if (!this._cachedSupportedChartTypes) {
			this._cachedSupportedChartTypes =
				this.GET(VIZREC_SUPPORTED_CHARTS_URL)
					.then( response => response.chartTypes )
		}
		return this._cachedSupportedChartTypes
	}

	/**
	 * Return only supported chart types that are included in vizTypes
	 *
	 * @param  {array} vizTypes
	 * @returns {promise}
	 */
	getSupportedChartTypes(vizTypes) {
		return this.getRecommenderSupportedChartTypes()
			.then( supportedVizTypes =>
				vizTypes.filter( vizType =>
					supportedVizTypes.indexOf( vizType ) > -1
				)
			)
	}

	getContentRecommendation(payload){
		return this.POST(CONTENT_RECOMMENDER_URL, payload)
	}

	getSmartModuleProgressSummary(moduleId){
		const url = `${SMART_MODULE_URL}/${moduleId}/progressSummary`
		return this.GET(url)
	}

	getVisRecommendation(payload) {
		return this.POST(VIZREC_RECOMMEND_URL, payload)
	}

}
